<template>
  <v-container class="fill-height">
    <v-row justify="center">
      <v-col align-self="center">
        <v-card
            v-if="this.resetParametersIsset"
            class="mx-auto px-6 py-8"
            max-width="400"
        >
          <p class="text-h5 mb-6">Reset password</p>
          <v-form
              v-model="valid"
              ref="resetPassword"
          >
            <v-text-field
                v-model="password"
                :readonly="loading"
                :type="showPass ? 'text' : 'password'"
                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="passwordRules"
                :clearable="true"
                label="Password"
                placeholder="Enter your password"
                @click:append="showPass = !showPass"
            />

            <v-text-field
                v-model="verify"
                :readonly="loading"
                :type="showPass ? 'text' : 'password'"
                :rules="passwordRules"
                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                :clearable="true"
                label="Password"
                placeholder="Confirm your password"
                @click:append="showPass = !showPass"
            />
            <p v-show="errorMessage !== null" class="text-subtitle-2 text-red">{{ errorMessage }}</p>
            <br>
            <v-btn
                :block="true"
                color="success"
                size="large"
                variant="elevated"
                @click="resetPassword(password)"
            >
              Update
            </v-btn>
            <v-overlay
                v-model="loading"
                :persistent="loading"
                :contained="true"
                class="align-center justify-center"
            >
              <v-progress-circular
                  indeterminate
                  size="64"
              />
            </v-overlay>
          </v-form>
        </v-card>
        <v-card v-if="!this.resetParametersIsset" class="mx-auto px-6 py-8">
          <p class="text-h5">Error</p>
          <p class="text-subtitle-1">Reset parameters don't set. Please verify reset link or contact mainroad.trade administrator.</p>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {auth} from "@/common/auth";
import {router} from "@/router";
import {readonly} from "vue";
import {messages} from "@/common/enum/messages";

export default {
  name: 'ResetPasswordView',
  computed: {
    resetParametersIsset() {
      return this.id && this.token
    }
  },
  data() {
    return {
      signRedirectionLink: readonly({
        name: 'sign-in'
      }),
      homeRedirectionLink: readonly({
        name: 'home'
      }),
      id: null,
      token: null,

      password: '',
      verify: '',

      valid: null,

      showPass: false,
      loading: false,

      errorMessage: null,

      passwordRules: [
        v => !!v || 'Password is required',
        v => /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/.test(v) || 'Password must contain at least lowercase letter, one number, a special character and one uppercase letter',
        v => v && (this.password === this.verify || !this.password || !this.verify) || 'Password must match in both fields',
      ],
    };
  },
  mounted() {
    if (auth.isAuthorized()) {
      router.push(this.homeRedirectionLink)
    }

    this.id = this.$route.query.id
    this.token = this.$route.query.token
  },
  methods: {
    resetPassword(password) {
      this.$refs.resetPassword.validate()
      if (this.valid !== true) {
        return
      }

      this.resetErrorMessage()
      this.loading = true
      auth.resetPassword(this.id, password, this.token, (responseMessage) => {
        this.loading = false
        if (responseMessage !== null) {
          this.errorMessage = responseMessage.length === 0 ? messages.en.reset_password_view.fatal_error : responseMessage
          return
        }

        router.push(this.signRedirectionLink)
      })
    },
    resetErrorMessage() {
      this.errorMessage = null
    }
  },
}
</script>

<style scoped>

</style>